__turbopack_context__.v({
  "badge": "badge-module-scss-module__30FM6q__badge",
  "badgeContainer": "badge-module-scss-module__30FM6q__badgeContainer",
});
